
(function(){
'use strict';
var cards=document.querySelectorAll('.evm__card');
var prefersReduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* Stagger reveal (vercel-react: rootMargin on observer) */
if(prefersReduced){
  cards.forEach(function(c){c.classList.add('is-visible');});
}else if('IntersectionObserver' in window){
  var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){
    if(e.isIntersecting){
      var idx=Array.prototype.indexOf.call(cards,e.target);
      setTimeout(function(){e.target.classList.add('is-visible');},idx*60);
      obs.unobserve(e.target);
    }
  });},{threshold:0.1,rootMargin:'0px 0px -30px 0px'});
  cards.forEach(function(c){obs.observe(c);});
}else{cards.forEach(function(c){c.classList.add('is-visible');});}

/* Three.js Shader — Smoke Effect (IDENTICAL logic). R13: touch + save-data + narrow-viewport + low-end gate. */
var isTouchDevice='ontouchstart' in window||navigator.maxTouchPoints>0;
var _amCon=(navigator.connection||navigator.mozConnection||navigator.webkitConnection||{});
var _amSaveData=!!(_amCon.saveData||/^(2g|slow-2g)$/.test(_amCon.effectiveType||''));
var _amLowEnd=(navigator.deviceMemory&&navigator.deviceMemory<4)||(navigator.hardwareConcurrency&&navigator.hardwareConcurrency<4);
var _amHoverNone=(window.matchMedia&&window.matchMedia('(hover: none)').matches);
var _amNarrow=(window.innerWidth<1024);
if(!isTouchDevice&&!prefersReduced&&!_amSaveData&&!_amLowEnd&&!_amHoverNone&&!_amNarrow){
function ensureThree(cb){if(typeof THREE!=='undefined'){cb();return;}var s=document.createElement('script');s.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';s.onload=cb;document.body.appendChild(s);}
var FS=[
'precision mediump float;',
'uniform vec2 u_resolution;uniform float u_time;uniform float u_hue;',
'vec3 hsv2rgb(vec3 c){vec4 K=vec4(1.0,2.0/3.0,1.0/3.0,3.0);vec3 p=abs(fract(c.xxx+K.xyz)*6.0-K.www);return c.z*mix(K.xxx,clamp(p-K.xxx,0.0,1.0),c.y);}',
'float rnd(vec2 st){return fract(sin(dot(st,vec2(12.9898,78.233)))*43758.5453);}',
'float ns(vec2 st){vec2 i=floor(st);vec2 f=fract(st);vec2 u=f*f*(3.0-2.0*f);return mix(mix(rnd(i),rnd(i+vec2(1,0)),u.x),mix(rnd(i+vec2(0,1)),rnd(i+vec2(1,1)),u.x),u.y);}',
'float fbm(vec2 st){float v=0.0;float a=0.5;for(int i=0;i<6;i++){v+=a*ns(st);st*=2.0;a*=0.5;}return v;}',
'mat2 rot(float a){return mat2(cos(a),-sin(a),sin(a),cos(a));}',
'void main(){',
'vec2 uv=(gl_FragCoord.xy*2.0-u_resolution.xy)/min(u_resolution.x,u_resolution.y);',
'float t=u_time;vec2 p=uv*rot(t*0.15);',
'float n1=fbm(p*1.2+vec2(t*0.12,t*0.22));',
'float n2=fbm(p*2.0+n1+vec2(-t*0.28,t*0.18));',
'float n3=fbm(p*3.2+n2+vec2(t*0.12,-t*0.22));',
'float fn=n1*0.6+n2*0.25+n3*0.15;',
'float s=0.65+fn*0.35;float v=0.12+pow(fn,2.2)*1.8;v+=pow(smoothstep(0.65,1.0,fn),2.5)*1.2;',
'vec3 col=hsv2rgb(vec3(u_hue/360.0+fn*0.12,s,v));',
'col*=1.0-smoothstep(0.5,1.4,length(uv));',
'float alpha=smoothstep(0.02,0.15,length(col))*0.85;',
'gl_FragColor=vec4(col,alpha);}'
].join('\n');
var VS='void main(){gl_Position=vec4(position,1.0);}';
var active={},leaveTimers={},ticking={};

function createShader(card,idx){
var imgWrap=card.querySelector('.evm__img-wrap');var mount=card.querySelector('.evm__shader');
if(!mount||!imgWrap||typeof THREE==='undefined')return null;
var w=imgWrap.clientWidth||200,h=imgWrap.clientHeight||200;
var renderer;try{renderer=new THREE.WebGLRenderer({antialias:false,alpha:true});}catch(e){return null;}
renderer.setPixelRatio(1);renderer.setSize(Math.round(w*0.5),Math.round(h*0.5),false);
renderer.domElement.style.width='100%';renderer.domElement.style.height='100%';
mount.appendChild(renderer.domElement);
var scene=new THREE.Scene(),cam=new THREE.OrthographicCamera(-1,1,1,-1,0,1);
var hue=(idx*37+263)%360;
var uni={u_time:{value:0},u_resolution:{value:new THREE.Vector2(w*0.5,h*0.5)},u_hue:{value:hue}};
var geo=new THREE.PlaneGeometry(2,2);
var mat=new THREE.ShaderMaterial({uniforms:uni,vertexShader:VS,fragmentShader:FS,transparent:true});
scene.add(new THREE.Mesh(geo,mat));
var start=performance.now(),fid=0;
function animate(){fid=requestAnimationFrame(animate);uni.u_time.value=(performance.now()-start)/1000;renderer.render(scene,cam);}
animate();
return{renderer:renderer,material:mat,geometry:geo,frameId:fid,mount:mount};
}

/* vercel-react: proper dispose + forceContextLoss */
function destroyShader(d){
if(!d)return;
cancelAnimationFrame(d.frameId);
if(d.mount&&d.renderer&&d.mount.contains(d.renderer.domElement))d.mount.removeChild(d.renderer.domElement);
if(d.geometry)d.geometry.dispose();
if(d.material)d.material.dispose();
if(d.renderer){d.renderer.forceContextLoss();d.renderer.dispose();}
}

ensureThree(function(){
cards.forEach(function(card,idx){
var inner=card.querySelector('.evm__card-inner');var glass=card.querySelector('.evm__glass');
var img=card.querySelector('.evm__img');var shaderEl=card.querySelector('.evm__shader');var key='evm-'+idx;

card.addEventListener('mouseenter',function(){
if(leaveTimers[key]){clearTimeout(leaveTimers[key]);leaveTimers[key]=null;}
if(!active[key])active[key]=createShader(card,idx);
if(shaderEl){shaderEl.classList.remove('is-leaving','is-active','is-settle');shaderEl.style.transform='scale(0)';shaderEl.style.opacity='0';}
requestAnimationFrame(function(){requestAnimationFrame(function(){
if(shaderEl){shaderEl.style.transform='';shaderEl.style.opacity='';shaderEl.classList.add('is-active');}
setTimeout(function(){if(shaderEl)shaderEl.classList.add('is-settle');},800);
});});
if(img){var hue=(idx*37+263)%360;var color='hsl('+hue+',70%,60%)';img.style.filter='drop-shadow(0 0 24px '+color+') drop-shadow(0 0 50px '+color+')';}
});

/* vercel-react: RAF throttle on mousemove */
card.addEventListener('mousemove',function(e){
if(ticking[key])return;
ticking[key]=true;
requestAnimationFrame(function(){
if(!inner){ticking[key]=false;return;}
var r=inner.getBoundingClientRect();
var x=e.clientX-r.left-r.width/2;
var y=e.clientY-r.top-r.height/2;
inner.style.transform='rotateX('+(-(y/r.height)*8)+'deg) rotateY('+((x/r.width)*8)+'deg)';
if(glass){glass.style.background='radial-gradient(circle at '+(e.clientX-r.left)+'px '+(e.clientY-r.top)+'px,rgba(255,255,255,0.06) 0%,transparent 50%)';glass.style.opacity='1';}
ticking[key]=false;
});
});

card.addEventListener('mouseleave',function(){
ticking[key]=false;
if(inner)inner.style.transform='rotateX(0) rotateY(0)';
if(glass)glass.style.opacity='0';if(img)img.style.filter='none';
if(shaderEl){shaderEl.classList.remove('is-active','is-settle');shaderEl.classList.add('is-leaving');}
leaveTimers[key]=setTimeout(function(){
if(shaderEl)shaderEl.classList.remove('is-leaving');
if(active[key]){destroyShader(active[key]);delete active[key];}leaveTimers[key]=null;
},550);
});
});
});
}

})();

/* --- Alle Modelle FAQ toggle --- R14: Read-Phase vor Write-Phase separiert, kein forced reflow */
(function(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.evm__faq-q');
    if(!btn)return;
    var item=btn.parentElement;
    var ans=item.querySelector('.evm__faq-a');
    var isOpen=btn.getAttribute('aria-expanded')==='true';
    var siblings=item.parentElement.querySelectorAll('.evm__faq-item');

    /* READ PHASE first — measure scrollHeight BEFORE any writes */
    var targetHeight=0;
    if(!isOpen) targetHeight=ans.scrollHeight;

    /* WRITE PHASE — all style mutations batched */
    for(var i=0;i<siblings.length;i++){
      if(siblings[i]!==item){
        var sb=siblings[i].querySelector('.evm__faq-q');
        var sa=siblings[i].querySelector('.evm__faq-a');
        if(sb)sb.setAttribute('aria-expanded','false');
        if(sa)sa.style.maxHeight='0';
        var svg=siblings[i].querySelector('.evm__faq-q svg');
        if(svg)svg.style.transform='';
      }
    }
    btn.setAttribute('aria-expanded',String(!isOpen));
    var qSvg=btn.querySelector('svg');
    if(!isOpen){ans.style.maxHeight=targetHeight+'px';if(qSvg)qSvg.style.transform='rotate(180deg)';}
    else{ans.style.maxHeight='0';if(qSvg)qSvg.style.transform='';}
  });
})();
